import React from 'react'
import { Box, Button, Paper, Text, TextInput } from '@mantine/core'
import { IconBuilding } from '@tabler/icons-react'
import { CompanySearchResult } from '../../hooks/useCompanySearch'

interface CompanySearchInputProps {
  value: string
  onChange: (value: string) => void
  error?: React.ReactNode
  searchResults: CompanySearchResult[]
  searching: boolean
  onSearch: () => void
  onSelect: (company: CompanySearchResult) => void
}

export default function CompanySearchInput({
  value,
  onChange,
  error,
  searchResults,
  searching,
  onSearch,
  onSelect,
}: CompanySearchInputProps) {
  return (
    <div style={{ position: 'relative' }}>
      <TextInput
        mt="md"
        placeholder="请输入公司名称关键字"
        leftSection={<IconBuilding size={16} />}
        rightSectionWidth={90}
        rightSection={
          <Button size="xs" variant="subtle" onClick={onSearch} disabled={searching}>
            搜索公司
          </Button>
        }
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
        error={error}
      />
      {searchResults.length > 0 && (
        <Paper
          shadow="md"
          p="xs"
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 1000,
            maxHeight: '200px',
            overflowY: 'auto',
          }}
        >
          {searchResults.map((company) => (
            <Box
              key={company.id}
              p="xs"
              style={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
              onClick={() => onSelect(company)}
            >
              <Text size="sm">{company.name}</Text>
              <Text size="xs" c="gray">
                统一社会信用代码：{company.creditCode}
              </Text>
              <Text size="xs" c="gray">
                {company.regStatus} | {company.base} | 注册资本：{company.regCapital}
              </Text>
            </Box>
          ))}
        </Paper>
      )}
    </div>
  )
}
